/**
 * Map data-component → loader.
 * Eager (intro / chrome) : import statique → reste dans le chunk principal.
 * Lazy : dynamic import → chunks séparés (Swiper, YouTube, forms…).
 */
import SiteLoader from "./site-loader.js";
import Header from "./header.js";
import Reveal from "./split-type.js";
import SiteFooter from "./site-footer.js";

const eager = (Ctor) => () => Promise.resolve({ default: Ctor });

export default {
	"site-loader": eager(SiteLoader),
	"header": eager(Header),
	"reveal": eager(Reveal),
	"site-footer": eager(SiteFooter),
	"testimony": () => import("./testimony.js"),
	"slider": () => import("./slider.js"),
	"article-list": () => import("./article-list.js"),
	"form-popin": () => import("./form-popin.js"),
	"drieux-form": () => import("./drieux-form.js"),
	"logos": () => import("./logos.js"),
	"push-article": () => import("./push-article.js"),
	"four-push": () => import("./four-push.js"),
	"three-push": () => import("./three-push.js"),
	"agencies": () => import("./agencies.js"),
	"decor-cabines": () => import("./decor-cabines.js"),
	"parallax-field": () => import("./parallax-field.js"),
	"faq": () => import("./faq.js"),
	"steps": () => import("./steps.js"),
	"reveal-flow": () => import("./reveal-flow.js"),
	"frame-parallax": () => import("./frame-parallax.js"),
	"numbers": () => import("./numbers.js"),
};
